import React, { useState, useEffect } from "react";
import * as Icons from "react-feather";
import { useList } from "store/list";
import Loading from "components/Loading";
import ListSearch from "components/list/ListSearch";
import ListPagination from "components/list/ListPagination";
import Add from "./Add";
import Edit from "./Edit";
import Delete from "./Delete";
import { handleSuccessMessages } from "store/auth";

export default function Channels() {
  const path = {
    baseRoute: "/panel/channels",
    aliasName: "کانال ها",
    type: "Channels",
  };
  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    create,
    update,
    remove,
    listSearch,
    from,
    to,
    total,
  } = useList();

  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [item, setItem] = useState(null);

  useEffect(() => {
    dispatch(getList(path));
    return () => {
      dispatch(clear());
    };
  }, []);

  return (
    <>
      <Add
        title="افزودن کانال"
        show={showAdd}
        close={() => setShowAdd(false)}
        submit={(values) => {
          dispatch(
            create(path, values, () => {
              handleSuccessMessages("کانال با موفقیت ایجاد شد");
              dispatch(getList(path));
            })
          );
        }}
      />

      <Edit
        item={item}
        title="ویرایش کانال"
        show={showEdit}
        close={() => setShowEdit(false)}
        submit={(values, id) => {
          dispatch(
            update(path, id, values, () => {
              handleSuccessMessages("کانال با موفقیت ویرایش شد");
              dispatch(getList(path));
            })
          );
        }}
      />

      <Delete
        title="حذف کانال"
        show={showDelete}
        close={() => setShowDelete(false)}
        submite={() => {
          dispatch(
            remove(path, list, item?.id, () => {
              handleSuccessMessages("کانال با موفقیت حذف شد");
              dispatch(getList(path));
              setShowDelete(false);
            })
          );
        }}
      />

      <div className="content" style={{ marginBottom: 80 }}>
        <h2 className="intro-y text-lg font-medium mt-10">کانال ها</h2>
        <div className="grid grid-cols-12 gap-6 mt-5">
          <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
            <button
              onClick={() => setShowAdd(true)}
              className="btn btn-primary shadow-md mr-2"
            >
              افزودن کانال
            </button>

            {load ? (
              <div className="hidden md:block mx-auto text-gray-600">
                در حال بارگذاری
              </div>
            ) : (
              <div className="hidden md:block mx-auto text-gray-600">
                {`نمایش ${from} تا ${to} از ${total}`}
              </div>
            )}

            <ListSearch search={(key) => dispatch(listSearch(path, key))} />
          </div>

          <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <table className="table table-report -mt-2">
              <thead>
                <tr>
                  <th className="whitespace-nowrap text-center">لوگو</th>
                  <th className="whitespace-nowrap text-center">پس‌زمینه</th>
                  <th className="whitespace-nowrap text-center">نام شبکه</th>
                  <th className="whitespace-nowrap text-center">ایجاد کننده</th>
                  <th className="whitespace-nowrap text-center">وضعیت</th>
                  <th className="whitespace-nowrap text-center">عملیات</th>
                </tr>
              </thead>

              {load && <Loading />}

              {!load && list && list.length === 0 && (
                <tbody>
                  <tr>
                    <td colSpan={6}>
                      <h3 className="w-full flex justify-center p-6">
                        چیزی یافت نشد
                      </h3>
                    </td>
                  </tr>
                </tbody>
              )}

              <tbody>
                {!load &&
                  list &&
                  list.length > 0 &&
                  list.map((row, idx) => (
                    <tr key={row.id ?? idx} className="intro-x">
                      <td className="w-16 text-center">
                        <div className="flex justify-center">
                          <div className="w-10 h-10 image-fit zoom-in">
                            <img
                              alt=""
                              className="tooltip rounded-full"
                              src={row?.logo?.url || ""}
                            />
                          </div>
                        </div>
                      </td>
                      <td className="w-16 text-center">
                        <div className="flex justify-center">
                          <div className="w-10 h-10 image-fit zoom-in">
                            <img
                              alt=""
                              className="tooltip rounded-full"
                              src={row?.backGround?.url || ""}
                            />
                          </div>
                        </div>
                      </td>

                      <td className="text-center">{row?.title || "-"}</td>
                      <td className="text-center">
                        {row?.author?.full_name || "-"}
                      </td>

                      <td className="text-center">
                        {row?.status ? (
                          <span className="text-green-500 text-xl">✔️</span>
                        ) : (
                          <span className="text-red-500 text-xl">❌</span>
                        )}
                      </td>
                      <td className="table-report__action w-56">
                        <div className="flex justify-center items-center">
                          <a
                            className="flex items-center ml-3 cursor-pointer"
                            onClick={() => {
                              setItem(row);
                              setShowEdit(true);
                            }}
                          >
                            <Icons.CheckSquare className="w-4 h-4 ml-1" />{" "}
                            ویرایش
                          </a>
                          <a
                            className="flex items-center text-theme-6 cursor-pointer"
                            onClick={() => {
                              setItem(row);
                              setShowDelete(true);
                            }}
                          >
                            <Icons.Trash2 className="w-4 h-4 ml-1" /> حذف
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          <ListPagination
            getList={(page, perPage) => dispatch(getList(path, page, perPage))}
          />
        </div>
      </div>
    </>
  );
}
